<template>
  <b-aspect aspect="16:9" class="mb-4">
    <div :class="`gift-card ${flipped ? 'is-flipped' : ''}`" @click="onFlip">
      <div :class="`gift-card-front gift-card-face ${hide_front ? 'd-none' : ''}`">
        <b-aspect aspect="16:9">
          <b-card>
            <b-row>
              <b-col class="col-auto">
                <h4><dollar :value="gift_card.balance"></dollar></h4>
              </b-col>
              <b-col class="text-right">
                <div>{{ organization.alias }}</div>
                <small class="d-block text-muted">{{ trans('gift_card') }}</small>
              </b-col>
            </b-row>
            <div class="m-4">
              <b-aspect aspect="3:1">
                <b-img v-if="organization.logo" :src="organization.logo" :alt="organization.name" center fluid style="max-height: 90px;"></b-img>
                <div v-if="!organization.logo" style="margin: 0 0 10px; color: #555555; font-weight: bold;">{{ organization.name }}</div>
              </b-aspect>
            </div>
          </b-card>
        </b-aspect>
      </div>

      <div class="gift-card-back gift-card-face">
        <b-aspect aspect="16:9">
          <b-card>
            <p class="text-center">
              <small>{{ trans('gift_card_redeemable_instructions').replace(':balance', this.balance).replace(':org', this.organization.alias) }}</small>
            </p>
            <h4 class="text-center">
              <code
                class="p-2 border"
                :title="trans('copy_to_clipboard')"
                v-b-tooltip
                @click.stop="onCopy"
                style="cursor: pointer;"
              >
                {{ gift_card.code_display }}
              </code>
            </h4>

            <div v-if="!!gift_card.recipient" class="text-center pt-2">
              <address class="d-inline-block text-left">
                <small class="d-block"><strong>{{ gift_card.recipient.name }}</strong></small>
                <small class="d-block"> {{ gift_card.recipient.email }}</small>
                <small v-if="gift_card.recipient.mobile" class="d-block">{{ gift_card.recipient.mobile }}</small>
              </address>
            </div>
            <p v-if="!gift_card.recipient" class="m-4">&nbsp;</p>

            <b-row>
              <b-col>
                <small class="text-muted">#{{ gift_card.no_display }}</small>
              </b-col>
              <b-col class="text-right">
                <small>Activity Messenger</small>
              </b-col>
            </b-row>
          </b-card>
        </b-aspect>
      </div>
    </div>
  </b-aspect>
</template>

<style>
  .gift-card {
    transform-style: preserve-3d;
    transform-origin: center right;
    transition: transform 1s;
  }
  .gift-card.is-flipped {
    transform: translateX(-100%) rotateY(-180deg);
  }
  .gift-card-face {
    position: absolute;
    backface-visibility: hidden;
    width: 100%;
  }
  .gift-card-back {
    transform: rotateY(180deg);
  }
</style>

<script>
  import Dollar from './../billing/Dollar'

  export default {
    props: {
      organization: Object,
      gift_card: Object,
    },
    components: {
      Dollar,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        flipped: false,
        hide_front: false,
        timer: null,
      }
    },
    computed: {
      balance() {
        return _.currency(this.gift_card.balance)
      },
    },
    methods: {
      onFlip() {
        if (this.flipped) {
          if (this.timer) clearTimeout(this.timer)
          this.hide_front = false
        } else {
          this.timer = setTimeout(() => {
            this.hide_front = true
            this.timer = null
          }, 1200)
        }
        this.flipped = !this.flipped
      },
      onCopy() {
        this.$copyText(this.gift_card.code, this.$el).then(() => {
          this.$bvToast.toast(this.gift_card.code, {
            title: trans('copied_to_clipboard'),
            autoHideDelay: 3000,
            variant: 'success',
            solid: true,
          })
        })
      },
    },
    mounted() {
      window['giftCard'+(this.gift_card.gift_card_no)] = this
    },
  }
</script>